
export enum AccountFactEntryType {
    CLIENT_ACCOUNT_DELETE_FUNNEL_OPENING_FORM_BUTTON_CLICK = 'client_account_delete_funnel_opening_form_button_click',
    CLIENT_ACCOUNT_DELETE_FUNNEL_CONFIRMATION_WINDOW_BUTTON_CLICK = 'client_account_delete_funnel_confirmation_window_button_click',
    FACT_AUTH_ACCOUNT_AUTH = 'fact_auth.account_auth'
}
